export const ACTenglishScoringMatrix = [
  0, 3, 4, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 15, 16, 16, 17, 17, 18, 19, 20,
  21, 22, 23, 24, 26, 28, 30, 32, 34, 36,
];

export const ACTmathScoringMatrix = [
  0, 6, 8, 10, 11, 13, 13, 14, 14, 14, 15, 16, 16, 16, 17, 17, 18, 18, 19, 20,
  21, 22, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 29, 30, 30, 31, 32, 33, 34,
  35, 36,
];

export const ACTmathScoringMatrixNew = [
  0, 6, 10, 12, 13, 14, 14, 15, 15, 16, 16, 17, 18, 18, 19, 20, 22, 23, 24, 24,
  25, 26, 27, 27, 28, 29, 31, 32, 34, 35, 36,
];

export const ACTreadingScoringMatrix = [
  0, 3, 5, 7, 9, 11, 12, 13, 14, 16, 17, 19, 21, 22, 23, 25, 27, 30, 32, 34, 36,
];

export const ACTreadingScoringMatrixNew = [
  0, 4, 6, 10, 11, 12, 13, 15, 17, 18, 20, 21, 24, 26, 28, 31, 34, 35, 36,
];

export const ACTscienceScoringMatrix = [
  0, 5, 7, 9, 11, 13, 14, 16, 17, 18, 20, 21, 22, 23, 24, 25, 27, 29, 32, 34,
  36,
];

export const SATverbalScoringMatrix = {
  easy: [
    [
      200, 200, 200, 200, 200, 200, 200, 320, 330, 340, 350, 370, 390, 410, 420,
      430, 430, 440, 450,
    ],
    [
      200, 200, 200, 200, 200, 200, 260, 340, 350, 360, 370, 390, 400, 420, 430,
      440, 450, 460, 470,
    ],
    [
      200, 200, 200, 200, 200, 200, 200, 340, 350, 360, 370, 390, 400, 420, 430,
      450, 460, 480, 480,
    ],
    [
      200, 200, 200, 200, 200, 200, 200, 350, 360, 360, 370, 390, 410, 430, 440,
      450, 460, 470, 480,
    ],
    [
      200, 200, 200, 200, 200, 200, 200, 360, 360, 370, 380, 400, 420, 440, 450,
      460, 470, 480, 490,
    ],
    [
      200, 200, 200, 200, 200, 200, 200, 360, 360, 370, 380, 400, 420, 440, 450,
      460, 470, 480, 500,
    ],
    [
      200, 200, 200, 200, 200, 200, 200, 360, 360, 370, 380, 400, 420, 440, 450,
      460, 470, 480, 500,
    ],
    [
      200, 200, 200, 200, 200, 200, 200, 250, 280, 330, 350, 400, 430, 450, 460,
      470, 480, 500, 500,
    ],
    [
      200, 200, 200, 200, 230, 290, 320, 360, 370, 380, 390, 410, 430, 450, 460,
      480, 490, 500, 510,
    ],
    [
      200, 200, 200, 200, 230, 290, 320, 360, 370, 380, 390, 410, 430, 450, 460,
      490, 500, 520, 530,
    ],
    [
      200, 260, 280, 340, 340, 360, 360, 380, 390, 400, 410, 430, 440, 460, 470,
      490, 500, 520, 530,
    ],
    [
      200, 260, 290, 350, 360, 360, 370, 390, 400, 420, 430, 450, 460, 480, 490,
      520, 530, 550, 560,
    ],
    [
      200, 210, 220, 260, 280, 310, 330, 360, 370, 400, 420, 450, 460, 490, 510,
      540, 550, 580, 590,
    ],
    [
      450, 460, 470, 480, 480, 490, 500, 520, 530, 550, 560, 580, 590, 610, 620,
      640, 650, 680, 700,
    ],
    [
      450, 470, 480, 500, 510, 530, 540, 560, 570, 590, 600, 620, 630, 640, 650,
      660, 670, 690, 710,
    ],
    [
      480, 490, 500, 510, 520, 530, 530, 550, 560, 580, 580, 600, 610, 640, 650,
      680, 690, 720, 730,
    ],
    [
      490, 500, 510, 520, 530, 540, 550, 560, 570, 580, 590, 610, 630, 650, 660,
      690, 700, 730, 740,
    ],
    [
      520, 530, 550, 560, 570, 590, 600, 610, 610, 640, 650, 670, 670, 690, 700,
      720, 730, 750, 770,
    ],
    [
      530, 540, 550, 570, 580, 580, 590, 600, 610, 630, 640, 650, 650, 670, 680,
      720, 730, 770, 800,
    ],
  ],
  hard: [[], [], [], [], [], [], [], [], [], [], [], [], []],
};

export const SATmathScoringMatrix = {
  easy: [
    [
      200, 260, 260, 270, 290, 290, 300, 330, 330, 340, 350, 360, 380, 390, 400,
      410, 410,
    ],
    [
      200, 270, 270, 270, 300, 300, 310, 340, 340, 360, 370, 370, 390, 400, 410,
      430, 430,
    ],
    [
      200, 280, 280, 280, 310, 310, 320, 350, 350, 370, 380, 380, 400, 410, 420,
      440, 440,
    ],
    [
      200, 280, 280, 290, 320, 320, 330, 360, 360, 380, 390, 390, 410, 420, 430,
      450, 450,
    ],
    [
      310, 320, 330, 330, 350, 350, 360, 370, 380, 390, 400, 400, 420, 430, 430,
      450, 460,
    ],
    [
      310, 310, 320, 330, 340, 350, 360, 360, 380, 390, 400, 400, 420, 430, 440,
      450, 470,
    ],
    [
      320, 320, 330, 330, 350, 360, 360, 370, 380, 400, 400, 400, 430, 440, 440,
      460, 480,
    ],
    [
      330, 340, 350, 360, 350, 360, 370, 380, 400, 410, 410, 410, 430, 440, 450,
      480, 500,
    ],
    [
      330, 330, 350, 350, 370, 370, 380, 380, 400, 420, 440, 450, 470, 480, 490,
      500, 510,
    ],
    [
      330, 340, 340, 350, 370, 370, 380, 400, 410, 420, 430, 430, 450, 460, 490,
      510, 540,
    ],
    [
      330, 340, 350, 350, 360, 370, 380, 400, 410, 430, 440, 440, 460, 480, 500,
      530, 550,
    ],
    [
      470, 480, 490, 500, 520, 530, 540, 560, 570, 590, 600, 610, 630, 640, 650,
      660, 680,
    ],
    [
      480, 500, 510, 520, 540, 550, 560, 580, 590, 610, 620, 620, 650, 660, 670,
      690, 700,
    ],
    [
      490, 510, 520, 530, 550, 560, 570, 590, 600, 620, 630, 640, 660, 670, 680,
      710, 720,
    ],
    [
      500, 520, 540, 550, 570, 580, 590, 600, 630, 650, 660, 670, 700, 710, 720,
      740, 760,
    ],
    [
      550, 560, 570, 580, 610, 620, 630, 650, 650, 680, 690, 710, 730, 740, 750,
      770, 800,
    ],
    [
      560, 580, 590, 590, 610, 620, 630, 650, 660, 680, 680, 680, 720, 740, 750,
      790, 800,
    ],
  ],
  hard: [[], [], [], [], [], [], [], [], [], [], []],
};

interface EqualityKey {
  [key: number]: number;
}

export const EqualityMatrix: EqualityKey = {
  0: 400,
  1: 430,
  2: 450,
  3: 470,
  4: 490,
  5: 510,
  6: 530,
  7: 550,
  8: 570,
  9: 590,
  10: 630,
  11: 679,
  12: 710,
  13: 760,
  14: 800,
  15: 850,
  16: 890,
  17: 930,
  18: 970,
  19: 1010,
  20: 1040,
  21: 1080,
  22: 1110,
  23: 1140,
  24: 1180,
  25: 1210,
  26: 1240,
  27: 1280,
  28: 1310,
  29: 1340,
  30: 1370,
  31: 1400,
  32: 1430,
  33: 1460,
  34: 1500,
  35: 1540,
  36: 1600,
};
